import user from "../../Assets/icone-user.png"

import React from 'react';
import './MarketingStatistics.scss';
import { FaFacebookF, FaEdit, FaLink, FaArrowUp } from 'react-icons/fa';
import { IoMdStats } from 'react-icons/io';
import { FiEdit2, FiLink2, FiTrash2 } from 'react-icons/fi';
import { RiErrorWarningLine } from "react-icons/ri";
import { PiArrowUpThin } from "react-icons/pi";
import { IoLogoFacebook } from "react-icons/io";
import { MdOutlineModeEdit } from "react-icons/md";
import { FiLoader } from "react-icons/fi";


const stats = [
  { label: 'People reached', value: '256k', change: '37.8%', icon: user },
  { label: 'People reached', value: '1.2x', change: '37.8%', icon: user },
  { label: 'Comments', value: '128', change: '37.8%', icon: user },
  { label: 'Link clicks', value: '80', change: '37.8%', icon: user },
];


  const products = [
    {
      id: 'YM',
      name: '3D dark mode wallpaper',
      subtext: 'Ads Product',
      status: 'Active',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'SM',
      name: 'Ads Services',
      subtext: 'Ads Prod',
      status: 'Active',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'TH',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Active',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    }
  ];

export default function MarketingStatistics() {
  return (
    <div className="dashboard">
  <div className="insights">
  {stats.map((stat, i) => (
    <div key={i} className="cards">
      <div className="d-flex align-items-center gap-5">
        <div>
          <div className="icon">
            <img src={stat.icon} alt={stat.label} />
          </div>
          <div className="info">
            <p>
              {stat.label} <RiErrorWarningLine className="warning-icon" />
            </p>
            <h2>{stat.value}</h2>
            <span className="positive">
              <PiArrowUpThin className="arrow-up" />
              {stat.change}
              <span className="this-week"> this week</span>
            </span>
          </div>
        </div>
        <div className="small-line"></div>
      </div>
    </div>
  ))}
</div>


       <div className="products-table">
           <table>
             <thead>
               <tr>
                
                 <th>Product</th>
                 <th>Distribution</th>
                 <th>Link ckicks</th>
                 <th>Views</th>
                 <th>Engagement</th>
              
               </tr>
             </thead>
             <tbody>
               {products.map((product) => (
                 <tr key={product.id}>

         <td>
     <div className="product-cell">
       <div className={`product-icon ${product.id.toLowerCase()}`}>
         {product.id}
       </div>
       <div className="product-info">
         <div className="product-name">{product.name}</div>
         <div className="product-subtext"><IoLogoFacebook/>
         <MdOutlineModeEdit/>
          <MdOutlineModeEdit/>
         </div>
       </div>
     </div>
   </td>
   
                   <td>
                     <span >
                     <span  style={{
                     backgroundColor:"#eaf4ff",
                     padding:"2px",
                     paddingLeft:"5px",
                     paddingRight:"5px",
                     borderRadius:"7px",
                      fontWeight:"bold",
                   }}>
                     {product.price}
                     </span>
                     </span>
   
                
                   </td>
                   <td> 
                    <div>

                        
  <div className="sales-info">
    <div className=" d-flex align-items-center gap-3">
     <span  style={{
                     backgroundColor:"#dedede",
                     fontWeight:"bold",
                     padding:"2px",
                     paddingLeft:"5px",
                     paddingRight:"5px",
                     borderRadius:"7px"
                   }}>{product.sales}</span>
                   <div
  className="side-div"
  style={{
    width: `${parseFloat(product.salesChange)}px`, // أو width بدل height
    backgroundColor: "#32a06e",
    borderRadius: "4px",
    height: "15px"
  }}
></div>
    </div>
                  
                       <span className="sales-change ">
                         <PiArrowUpThin/>
                       {product.salesChange}</span>
                     </div>
                                          

                    </div>
                  </td>


                   <td>
                 <div className="sales-info">
    <div className=" d-flex align-items-center gap-3">
     <span  style={{
                     backgroundColor:"#dedede",
                     fontWeight:"bold",
                     padding:"2px",
                     paddingLeft:"5px",
                     paddingRight:"5px",
                     borderRadius:"7px"
                   }}>{product.sales}</span>
<div
  className="side-div"
  style={{
    width: `${parseFloat(product.salesChange)}px`, // أو width بدل height
    backgroundColor: "#32a06e",
    borderRadius: "4px",
    height: "15px"
  }}
></div>

    </div>
                  
                       <span className="sales-change ">
                         <PiArrowUpThin/>
                       {product.salesChange}</span>
                     </div>
                   </td>
                   <td >
                      <div className="sales-info">
    <div className=" d-flex align-items-center gap-3">
     <span  style={{
                     backgroundColor:"#dedede",
                     fontWeight:"bold",
                     padding:"2px",
                     paddingLeft:"5px",
                     paddingRight:"5px",
                     borderRadius:"7px"
                   }}>{product.sales}</span>
                   <div
  className="side-div"
  style={{
    width: `${parseFloat(product.salesChange)}px`, // أو width بدل height
    backgroundColor: "#32a06e",
    borderRadius: "4px",
    height: "15px"
  }}
></div>
    </div>
                  
                       <span className="sales-change ">
                         <PiArrowUpThin/>
                       {product.salesChange}</span>
                     </div></td>
                  
                 </tr>
               ))}
             </tbody>
           </table>
                 
         </div>
         <div className=" d-flex align-items-center justify-content-center div-btn">
            <button className="load-btn">
             <FiLoader/>   Load more
            </button>
            </div> 
    </div>
  );
}